document.addEventListener( 'DOMContentLoaded', () => {

  // SELECTORS

  const
    body = document.querySelector( 'body' ),
    burger = document.querySelector( '#burger' ),
    localeIcon = document.querySelector( '#localization' ),
    searchIcon = document.querySelector( '#search-toggle' ),
    primaryNav = document.querySelector( 'header nav' ),
    searchbar = document.querySelector( '#searchbar' ),
    secondaryNav = document.querySelector( 'main nav' ),
    search = document.querySelector( '#Search' ),
    predictiveSearchResults = document.querySelector( '#predictive-search' ),
    localeOverlay = document.querySelector( '#localeOverlay' ),
    localeOverlayModal = document.querySelector( '#localeOverlay .localeModal' ),
    toggleTextButtons = document.querySelectorAll( '#toggle-text' ),
    productVariantSelect = document.querySelector( '#product-variant-select' ),
    quantitySelectors = document.querySelectorAll( '.quantity-selector' ),
    anchors = document.querySelectorAll( '[data-anchor]' ),
    videoTeasers = document.querySelectorAll( '.teaser-video' ),
    now = new Date();
  
  let
    scrollMargin = parseInt( getComputedStyle(document.documentElement).getPropertyValue( '--header-offset' ).replace( 'px', '' ) ) + parseInt( getComputedStyle(document.documentElement).getPropertyValue( '--header-height' ).replace( 'px', '' ) ) + parseInt( getComputedStyle(document.documentElement).getPropertyValue( '--header-top' ).replace( 'px', '' ) );
    isDragging = false; 


  // FUNCTIONS
  
  
  // Toggle menu
  
  const headerToggle = ( target ) => {
    burger.classList.toggle( 'burger-close' );
    
    if ( target === "nav" ) {
      primaryNav.classList.toggle( 'block' );
      if ( secondaryNav ) {
        secondaryNav.classList.toggle( 'block' );
      }
    } else if ( target === "search" ) {
      if ( searchbar.classList.contains( 'block' ) ) {
        search.value = '';
        predictiveSearchResults.classList.remove('block');
      }
  
      if ( secondaryNav ) {
        if ( searchbar.classList.contains( 'block' ) ) {
          secondaryNav.classList.remove( 'searchbar-offset' );
          secondaryNav.style.marginTop = '';
        } else {
          secondaryNav.classList.add( 'searchbar-offset' );
        }
      }
      
      searchbar.classList.toggle( 'block' );
      searchbar.querySelector("input").focus();
      
      if ( primaryNav.classList.contains( 'block' ) ) {
        burger.classList.toggle( 'burger-close' );
        primaryNav.classList.toggle( 'block' );
      }
    }
  }
  
  burger.addEventListener( 'click', ( ) => {
    if ( searchbar.classList.contains( 'block' ) ) {
      headerToggle( "search" );
    } else {
      headerToggle( "nav" );
    }
  })

  if ( ! document.body.classList.contains( "template-search" ) ) {
    searchIcon.addEventListener( 'click', ( ) => {
      headerToggle( "search" );
    })
  }
  
  /*
  // No auto-open menu on homepage for the moment
   
  if ( body.classList.contains( 'template-index' ) && ( localStorage.getItem( 'artekMenuOpened') != now.getDay() )) {
    toggleMenu();
    localStorage.setItem( 'artekMenuOpened', now.getDay() );
  }
  */
  
  
  // Show locale switcher
  
  const showLocaleSelector = ( ) => {
    localeOverlay.classList.toggle( 'flex' );
    document.querySelector('#language').focus();
  }
  
  if ( !localStorage.getItem( 'artekLocaleSet' )) {
    showLocaleSelector();
    localStorage.setItem( 'artekLocaleSet', true );
  }
    
  localeIcon.addEventListener( 'click', ( ) => {
    showLocaleSelector();
  })

  localeOverlayModal.addEventListener( 'click', ( event ) => {
    event.stopPropagation();
  })
  
  localeOverlay.addEventListener( 'click', ( ) => {
    localeOverlay.classList.remove( 'flex' );
  })

  
  // Toggle collapsed text

  if ( toggleTextButtons ) {
    toggleTextButtons.forEach( ( toggleTextButton ) => {
      toggleTextButton.addEventListener('click', ( event ) => {
        event.target.previousElementSibling.classList.toggle( 'collapsed' );
  
        if ( toggleTextButton.innerHTML === 'Read more' ) {
          toggleTextButton.innerHTML = 'Read less';
        } else {
          toggleTextButton.innerHTML = 'Read more';
        }
      } );
    } )
  }
  
  // Visual product variant selector
  
  if ( productVariantSelect ) {
    const 
      variants = productVariantSelect.querySelectorAll( 'option' ),
      visualVariants = document.querySelectorAll( '#product-variant-images li' ),
      productForms = document.querySelectorAll( '.shopify-product-form' ),
      selects = document.querySelectorAll( 'select[name="id"]' ),
      inquireButtons = document.querySelectorAll( 'a.made-to-order '),
      priceLabels = document.querySelectorAll( 'span.product-price' ),
      mainImage = document.querySelector( '#mainImage' ),
      variantRestockInfo = document.querySelector( '#variant-restock' ),
      variantRestockInfoContent = document.querySelector( '#variant-restock p' ),
      madeToOrderInfo = document.querySelector( '#madeToOrderInfo' ),
      deliveryTimeInfo = document.querySelector( '#deliveryTime' ),
      freeShippingInfo = document.querySelector( '#freeShipping' ),
      productState = document.querySelectorAll('.product-state');
    
    // Update restock information per variant if available
    const updateRestock = () => {
      const selectedVariantElement = document.querySelector( '#product-variant-images li[data-variant="'+productVariantSelect.value+'"]' );
      
      if ( (selectedVariantElement.getAttribute('data-restock') != '') && (selectedVariantElement.getAttribute('data-availability') == 'false') ) {
        variantRestockInfoContent.textContent = selectedVariantElement.getAttribute('data-restock');
        variantRestockInfo.classList.remove('hidden');
      } else {
        variantRestockInfo.classList.add('hidden');
      }
    }

    // Update made to order information per variant if available
    const updateMadeToOrder = () => {
      const selectedVariantElement = document.querySelector( '#product-variant-images li[data-variant="'+productVariantSelect.value+'"]' );
      if ( (selectedVariantElement.getAttribute('data-madetoorder') == 'true') ) {
        madeToOrderInfo.classList.remove('hidden');
      } else {
        madeToOrderInfo.classList.add('hidden');
      }
    }
    
    const updateDeliveryInfo = () => {
      const selectedVariantElement = document.querySelector( '#product-variant-images li[data-variant="'+productVariantSelect.value+'"]' );
      const isAvailable = selectedVariantElement.getAttribute('data-availability') == 'true';

      if ( deliveryTimeInfo ) {
        deliveryTimeInfo.classList.toggle('hidden', !isAvailable);
      }
    }

    visualVariants.forEach( ( li ) => {
      
      if ( !li.classList.contains(' disabled' ) ) {
        li.addEventListener( 'click', ( event ) => {
          const 
            variantId = event.target.closest('li').getAttribute('data-variant'),
            variantPrice = event.target.closest('li').getAttribute('data-price'),
            li = event.target.closest( 'li' );
          
          visualVariants.forEach( ( variant ) => {
            variant.classList.remove( 'selected' );
          })
          
          productVariantSelect.value = variantId;
          
          selects.forEach( ( select ) => {
            select.value = variantId;
          })
          
          priceLabels.forEach( ( label ) => {
            label.innerText = variantPrice;
          })
          
          if ( li.getAttribute( 'data-availability' ) == 'true' ) {
            productState.forEach((el) => { el.setAttribute('data-state','available')})
          } else if ( li.hasAttribute( 'data-madeToOrder' ) ) {
            productState.forEach((el) => { el.setAttribute('data-state','madeToOrder')})
            inquireButtons.forEach((btn) => {
              btn.setAttribute('href', 'mailto:'+li.getAttribute('data-inquiryHref'));
            })
          } else if (li.getAttribute('data-sellsOut') == 'true') {
            productState.forEach((el) => { el.setAttribute('data-state','soldOut')})
          } else {
            productState.forEach((el) => { el.setAttribute('data-state','comingSoon')})
          }
          
          li.classList.add( 'selected' );
          mainImage.srcset = li.getAttribute('data-srcset');
          mainImage.src = li.getAttribute('data-src');
          
          updateRestock();
          updateMadeToOrder();
          updateDeliveryInfo();
        })
        
        li.addEventListener( 'mouseenter', ( event ) => {
          const variantId = event.target.closest('li').getAttribute('data-variant');
          productVariantSelect.value = variantId;
        }) 
      }
    })
    
    updateRestock();
    updateMadeToOrder();
    updateDeliveryInfo();
  }

  // Update quantity in cart
  
  if ( body.classList.contains( 'template-cart' ) ) {
    quantitySelectors.forEach( ( quantitySelector ) => {
      const 
        input = quantitySelector.querySelector( '[name="updates[]"]' ),
        decreaser = quantitySelector.querySelector( '.decrease' ),
        increaser = quantitySelector.querySelector( '.increase' ),
        max = input.getAttribute( 'max' );

      decreaser.addEventListener( 'click', () => {
        if ( parseInt( input.value ) > 1 ) {
          input.value = parseInt( input.value ) - 1;
        }
      } );

      increaser.addEventListener( 'click', () => {
        if ( parseInt( input.value ) < max ) {
          input.value = parseInt( input.value ) + 1;
        }
      } );
    } );
  }
  
  
  // Video fallback for unconsented cookies
  
  videoTeasers.forEach( ( videoTeaser ) => {
    const
      frame = videoTeaser.querySelector( 'iframe' ),
      attr = frame.getAttribute( 'data-cookieblock-src' ),
      message = videoTeaser.querySelector( '#consentBlockNote' ),
      wrapper = message.parentElement,
      banner = document.querySelector( '#cookiebanner' ),
      cta = videoTeaser.querySelector( '#SubmitCustomConsent' );
    
    if ( attr === null || attr === false || attr === undefined ) {
      message.remove();
    }
    
    cta.onclick = () => {
      Cookiebot.submitCustomConsent(true,true,true)
    }
    
    window.addEventListener( 'CookiebotOnAccept', (e) => {
      message.remove();
      wrapper.classList.add( 'ratio16-9' );
      if ( banner ) banner.style.display = "none";
    }, false);
  } );
  
  
  // Responsive sliders
  
  const flexSliders = document.querySelectorAll( '.flex-slider ol' );
  
  if ( flexSliders ) {
    flexSliders.forEach( ( flexSlider ) => {
      let responsiveSlider;
    
      if ( matchMedia ( 'screen and ( max-width: 768px )' ).matches ) {
        responsiveSlider = new Flickity( flexSlider, {
          wrapAround: true,
          pageDots: false,
          prevNextButtons: false,
          imagesLoaded: true,
          selectedAttraction: 0.15,
          friction: 0.85
        });
      }
    
      window.addEventListener( 'resize', () => {
        if ( matchMedia ( 'screen and ( max-width: 768px )' ).matches ) {
          responsiveSlider = new Flickity( flexSlider, {
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            imagesLoaded: true,
            selectedAttraction: 0.15,
            friction: 0.85
          });
        } else {
          if ( responsiveSlider ) {
            responsiveSlider.destroy();
          }
        }
      } );
    } );
  }
  
  
  // Anchor function
  
  let flkty;
  
  if ( anchors.length > 0 ) {
    const anchorNav = document.createElement( 'nav' );
    anchorNav.classList.add( 'block' );
    
    anchorNavInner = document.createElement( 'anchor-component' );
    anchorNavInner.classList.add( 'ui-element' );
    anchorNav.appendChild( anchorNavInner );
    
    document.querySelector( 'main' ).prepend( anchorNav );
    
    const navPlaceholderItem = document.createElement( 'div' );
    navPlaceholderItem.classList.add( 'placeholder' );
    anchorNavInner.appendChild( navPlaceholderItem );
    
    Array.from( anchors ).map( ( anchor, index ) => {
      const navItem = document.createElement( 'div' );
      navItem.innerHTML = anchor.querySelector( 'ol > li:first-child > p' ).textContent;
      navItem.setAttribute( 'data-cta', anchor.getAttribute( 'data-anchor' ) );
      anchorNavInner.appendChild( navItem );
      
      // Init Flickity in last loop
      if ( index === anchors.length - 1 ) {
        flkty = new Flickity( anchorNavInner, {
          pageDots: false,
          prevNextButtons: false,
        });
        
        flkty.on( 'staticClick', ( event, pointer, cellElement, cellIndex ) => {
          const a = document.querySelector( `[data-anchor="${cellElement.getAttribute( 'data-cta' )}"]` );
          a.scrollIntoView();
          setTimeout( () => { flkty.select( cellIndex, false, false ); }, 66 );
        } );
        
        flkty.on( 'dragStart', () => {
          isDragging = true;
        } );
        
        flkty.on( 'settle', ( index ) => {
          const a = anchors[ index - 1 ];
          
          if ( isDragging ) {
            if ( index - 1 >= 0 ) {
              a.scrollIntoView();
            } else {
              document.querySelector( '.page-header' ).scrollIntoView();
            }
          }
          
          setTimeout( () => { isDragging = false; }, 66 );
        } );
      }
    } );
    
    // Re calculate sroll margin
    window.onresize = () => {
      scrollMargin = parseInt( getComputedStyle(document.documentElement).getPropertyValue( '--header-offset' ).replace( 'px', '' ) ) + parseInt( getComputedStyle(document.documentElement).getPropertyValue( '--header-height' ).replace( 'px', '' ) ) + parseInt( getComputedStyle(document.documentElement).getPropertyValue( '--header-top' ).replace( 'px', '' ) );
    }
  }
  
  
  // Responsive navigation on scroll
  
  const closableNav = document.querySelector( '[data-navigation-state="open"]' );
  
  if ( secondaryNav ) {
    // Make sure nav is accessible, even when it's out of viewport
    secondaryNav.onclick = () => {
      if ( secondaryNav.getBoundingClientRect().bottom >= window.innerHeight ) {
        secondaryNav.setAttribute( "data-scroll", true );
      } else {
        secondaryNav.setAttribute( "data-scroll", false );
      }
    }
  }
  
  // Image ratio classes in rich text
  // Image caption from alt text in rich text
  
  const wrap = ( el, wrapper ) => {
    if ( el && el.parentNode ) {
      el.parentNode.insertBefore( wrapper, el );
      wrapper.appendChild( el );
    }
  }
  
  const imagesInRichtext = document.querySelectorAll( '.richtext img' );
  
  if ( imagesInRichtext.length > 0 ) {
    Array.from( imagesInRichtext ).map( ( imageInRichtext ) => {
      imageInRichtext.onload = () => {
        
        // Ratio
        const figure = document.createElement( 'figure' );
        
        if ( imageInRichtext.naturalWidth < imageInRichtext.naturalHeight ) {
          figure.classList.add( 'portrait' );
        } else if ( imageInRichtext.naturalWidth === imageInRichtext.naturalHeight ) {
          figure.classList.add( 'square' );
        } else {
          figure.classList.add( 'landscape' );
        }
        
        wrap( imageInRichtext, figure );
        
        // Caption
        const alt = imageInRichtext.getAttribute( 'alt' );
        
        if ( alt ) {
          const figcaption = document.createElement( 'figcaption' );
          
          figcaption.classList.add( 'darkgrey' );
          figcaption.innerHTML = alt;
          figure.appendChild( figcaption );
        }
      }
    } );
  }
  
  
  // ON SCROLL
  
  window.onscroll = ( event ) => {
    
    // Responsive navigation
    
    if ( secondaryNav ) {
      if ( secondaryNav.getAttribute( "data-scroll" ) ) {
        secondaryNav.scroll( 0, window.pageYOffset );
      }
    }
    
    // Collapse navigation
    
    if ( closableNav ) {
      const
        isMobile = matchMedia( 'screen and ( max-width: 768px )' ).matches,
        isClosed = closableNav.getAttribute( 'data-navigation-state' ) === 'closed',
        openThreshold = isMobile ? window.innerHeight : window.innerHeight * .666666;

      let closeThreshold = openThreshold;

      if ( isMobile && !isClosed ) {
        const navBottom = closableNav.getBoundingClientRect().bottom + window.pageYOffset - window.innerHeight;
        closeThreshold = Math.max( openThreshold, navBottom );
      }

      if ( window.pageYOffset > closeThreshold ) {
        closableNav.setAttribute( 'data-navigation-state', 'closed' );
      } else if ( window.pageYOffset <= openThreshold ) {
        closableNav.setAttribute( 'data-navigation-state', 'open' );
      }
    }
    // Progress anchor navigation on scroll
    
    if (
      document.body.classList.contains( 'template-collection-second-cycle' ) ||
      document.body.classList.contains( 'template-collection-shop-all' )
    ) {
      const sections = document.querySelectorAll( '.page-header, [data-anchor]' );
      
      console.log( scrollMargin );
      
      Array.from( sections ).map( ( section, index ) => {
        if ( section.getBoundingClientRect().top < scrollMargin && section.getBoundingClientRect().bottom > scrollMargin ) {
          if ( ! isDragging ) {
            flkty.select( index );
          }
        }
      } );
    }
  }

} );
